import styled from 'styled-components';
import { color } from '@deerplusofficial/pos-helper';

export default styled.input.attrs({ type: 'text' })`
  display: block;
  padding: 14px;
  margin-top: 20px;
  line-height: 1.5;
  color: ${color.text.info};
  border-radius: 2px;
  border: 1px solid ${color.border};
  box-shadow: none;
  outline: 0;
`;



// WEBPACK FOOTER //
// ./src/components/Input/Input.js